import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {PerkAccessWDto} from '@cohort/wallet-schemas/perkAccess';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface PerkAccessesDetailsProps {
  perkAccesses: PerkAccessWDto[];
  helperText?: string;
}

export const PerkAccessesDetails: React.FC<PerkAccessesDetailsProps> = ({
  perkAccesses,

  helperText,
}) => {
  const {t} = useTranslation('components', {keyPrefix: 'space.nftTransfer.perkAccessesDetails'});
  const {backgroundColor, hasDarkBg} = useThemeContext();

  return (
    <div style={{backgroundColor}}>
      {/* 222px = Height of 4,6 perks rows */}
      <div
        className={classNames(
          'no-scrollbar overflow-auto rounded-lg border lg:max-h-[222px]',
          hasDarkBg ? ' border-white/20' : ' border-black/20'
        )}
      >
        {perkAccesses.map(perkAccess => {
          return (
            <div
              className={classNames(
                'flex justify-between border-b px-5 py-[10px] leading-7 last:border-b-0',
                hasDarkBg ? ' border-white/20' : ' border-black/20'
              )}
              key={perkAccess.id}
            >
              <div
                className={classNames(
                  'pr-3 text-sm font-semibold',
                  hasDarkBg ? 'text-white' : 'text-black/90'
                )}
              >
                {perkAccess.perk.displayName}
              </div>
              <div
                className={classNames(
                  hasDarkBg ? 'text-white/50' : 'text-black/50',
                  'text-sm font-medium'
                )}
              >
                {perkAccess.reachedMaxUsages ? t('usedPerk') : t('unusedPerk')}
              </div>
            </div>
          );
        })}
      </div>
      {helperText !== undefined && (
        <p className={classNames(hasDarkBg ? 'text-white/50' : 'text-black/50', 'mt-2 text-sm')}>
          {helperText}
        </p>
      )}
    </div>
  );
};

PerkAccessesDetails.displayName = 'PerkAccessesDetails';
